import React from 'react'
import styles from './GuideModal.module.scss'
import DraftHTML from "../../../../../components/draftEditor/export/DraftHTML";
import {
    HOWTO_CHANGE_DNS_A, HOWTO_CHANGE_DNS_BLUEHOST,
    HOWTO_CHANGE_DNS_DREAMHOST, HOWTO_CHANGE_DNS_GODADDY,
    HOWTO_CHANGE_DNS_NAME, HOWTO_CHANGE_DNS_NAMECHEAP
} from "../../../../../settings/content/linksExternal";

const links = [
    {link: HOWTO_CHANGE_DNS_GODADDY, title: 'GoDaddy'},
    {link: HOWTO_CHANGE_DNS_NAMECHEAP, title: 'Namecheap'},
    {link: HOWTO_CHANGE_DNS_BLUEHOST, title: 'Bluehost'},
    {link: HOWTO_CHANGE_DNS_NAME, title: 'Name.com'},
    {link: HOWTO_CHANGE_DNS_DREAMHOST, title: 'Dreamhost'},
    {link: HOWTO_CHANGE_DNS_A, title: 'Other domain registrars'},
]

export default function GuideModal({seo}) {
    return seo.custom.dashboard_next.map((step, index) => (
        <div className={styles.block} key={index}>
            <h4 className={styles.title}>{step.title}</h4>
            <DraftHTML
                className={styles.content}
                content={step.content}
            />
        </div>
    ));
}